import { useMemo } from 'react';
import { getCioClient } from '../utils';
const useCioClient = ({ apiKey, cioJsClient, cioJsClientOptions }) => {
    if (!apiKey && !cioJsClient) {
        // eslint-disable-next-line no-console
        console.error('Either apiKey or cioJsClient is required');
    }
    return useMemo(() => cioJsClient || getCioClient(apiKey, cioJsClientOptions), [apiKey, cioJsClient, cioJsClientOptions]);
};
export default useCioClient;
